import React from "react";
import Navbar from '../../components/Navbar'

function PrivacyAndPolicy() {
    return (
        <>
            <Navbar />
            <div className="container">
                <div className="justify-content-sm-center pt-5">
                    <h2 style={{ textAlign: "center", padding: "13%" }}>
                        <u>PRIVACY POLICY</u>
                    </h2>
                    <h5>Last Updated: Oct 24, 2025</h5>
                    <br />
                </div>

                <div className="row">
                    {/* WHAT DO WE DO WITH YOUR INFORMATION */}
                    <div className="col-md-12">
                        <h4>WHAT DO WE DO WITH YOUR INFORMATION?</h4>
                        <ul style={{ color: "black" }} className="custom-li-bullet-points">
                            <li>
                                When you subscribe our company product FleetOrder (includes
                                Website, Mobile Applications), as part of the subscription
                                process, we collect the personal information you give us such as
                                your name, address and email address.
                            </li>
                            <li>
                                We use your information in order to provide better service or if
                                any problem occurred while subscribing to our product.
                            </li>
                            <li>
                                Email marketing (if applicable): With your permission, we may send
                                you emails about our product updates.
                            </li>
                        </ul>
                    </div>

                    {/* CONSENT */}
                    <div className="col-md-12">
                        <br />
                        <h4>CONSENT</h4>
                        <ul style={{ color: "black" }} className="custom-li-bullet-points">
                            <div>
                                <h5>How do you get my consent?</h5>
                                <li>
                                    When you provide us with personal information to complete a
                                    transaction, verify your credit card, subscribe to product, we
                                    imply that you consent to our collecting it and using it for
                                    that specific reason only.
                                </li>
                                <li>
                                    If we ask for your personal information for a secondary reason,
                                    like marketing, we will either ask you directly for your
                                    expressed consent, or provide you with an opportunity to say no.
                                </li>
                            </div>
                            <br />
                            <div>
                                <h5>How do I withdraw my consent?</h5>
                                <li>
                                    If after you opt-in, you change your mind, you may withdraw your
                                    consent for us to contact you, for the continued collection, use
                                    or disclosure of your information, at any time, by contacting us
                                    at{" "}
                                    <a
                                        href="mailto:sales@fleetorder.in"
                                        style={{ textDecoration: "none" }}
                                    >
                                        info@fleetorder.in
                                    </a>{" "}
                                    or Thub Phase 2, 20, Inorbit Mall Rd, Vittal Rao Nagar, Madhapur, Hyderabad, Telangana 500081
                                </li>
                            </div>
                        </ul>
                    </div>

                    {/* DISCLOSURE */}
                    <div className="col-md-12">
                        <br />
                        <h4>DISCLOSURE</h4>
                        <ul style={{ color: "black" }} className="custom-li-bullet-points">
                            <li>
                                We may disclose your personal information if we are required by
                                law to do so or if you violate our Terms of Service.
                            </li>
                        </ul>
                    </div>

                    {/* PAYMENT */}
                    <div className="col-md-12">
                        <br />
                        <h4>PAYMENT</h4>
                        <ul style={{ color: "black" }} className="custom-li-bullet-points">
                            <li>
                                We use a payment gateway integrator for processing payments. We or
                                our payment gateway integrator do not store your card data on
                                their servers. The data is encrypted through the Payment Card
                                Industry Data Security Standard (PCI-DSS) when processing payment.
                                Your purchase transaction data is only used as long as is
                                necessary to complete your purchase transaction. After that is
                                complete, your purchase transaction information is not saved.
                            </li>
                            <li>
                                Our payment gateway adheres to the standards set by PCI-DSS as
                                managed by the PCI Security Standards Council, which is a joint
                                effort of brands like Visa, MasterCard, American Express and
                                Discover.
                            </li>
                            <li>
                                PCI-DSS requirements help ensure the secure handling of credit
                                card information by our platform and its service providers.
                            </li>
                        </ul>
                    </div>

                    {/* THIRD-PARTY SERVICES */}
                    <div className="col-md-12">
                        <br />
                        <h4>THIRD-PARTY SERVICES</h4>
                        <ul style={{ color: "black" }} className="custom-li-bullet-points">
                            <li>
                                In general, the third-party providers used by us will only
                                collect, use and disclose your information to the extent necessary
                                to allow them to perform the services they provide to us.
                            </li>
                            <li>
                                However, certain third-party service providers, such as payment
                                gateways and other payment transaction processors, have their own
                                privacy policies in respect to the information we are required to
                                provide to them for your purchase-related transactions.
                            </li>
                            <li>
                                For these providers, we recommend that you read their privacy
                                policies so you can understand the manner in which your personal
                                information will be handled by these providers.
                            </li>
                            <li>
                                In particular, remember that certain providers may be located in
                                or have facilities that are located in a different jurisdiction
                                than either you or us. So if you elect to proceed with a
                                transaction that involves the services of a third-party service
                                provider, then your information may become subject to the laws of
                                the jurisdiction(s) in which that service provider or its
                                facilities are located.
                            </li>
                            <li>
                                Once you leave our FleetOrder website or are redirected to a
                                third-party website or application, you are no longer governed by
                                this Privacy Policy or our website’s Terms of Service.
                            </li>
                        </ul>
                    </div>

                    {/* LINKS */}
                    <div className="col-md-12">
                        <br />
                        <h4>LINKS</h4>
                        <ul style={{ color: "black" }} className="custom-li-bullet-points">
                            <li>
                                When you click on links on our FleetOrder Website, they may direct
                                you away from our site. We are not responsible for the privacy
                                practices of other sites and encourage you to read their privacy
                                statements.
                            </li>
                        </ul>
                    </div>

                    {/* SECURITY */}
                    <div className="col-md-12">
                        <br />
                        <h4>SECURITY</h4>
                        <ul style={{ color: "black" }} className="custom-li-bullet-points">
                            <li>
                                To protect your personal information, we take reasonable
                                precautions and follow industry best practices to make sure it is
                                not inappropriately lost, misused, accessed, disclosed, altered or
                                destroyed.
                            </li>
                        </ul>
                    </div>

                    {/* COOKIES */}
                    <div className="col-md-12">
                        <br />
                        <h4>COOKIES</h4>
                        <ul style={{ color: "black" }} className="custom-li-bullet-points">
                            <li>
                                We use cookies to maintain session of your user. It is not used to
                                personally identify you on other websites.
                            </li>
                        </ul>
                    </div>

                    {/* AGE OF CONSENT */}
                    <div className="col-md-12">
                        <br />
                        <h4>AGE OF CONSENT</h4>
                        <ul style={{ color: "black" }} className="custom-li-bullet-points">
                            <li>
                                By using this site, you represent that you are at least the age of
                                majority in your state or province of residence, or that you are
                                the age of majority in your state or province of residence and you
                                have given us your consent to allow any of your minor dependents
                                to use this site.
                            </li>
                        </ul>
                    </div>

                    {/* CHANGES TO PRIVACY POLICY */}
                    <div className="col-md-12">
                        <br />
                        <h4>CHANGES TO THIS PRIVACY POLICY</h4>
                        <ul style={{ color: "black" }} className="custom-li-bullet-points">
                            <li>
                                We reserve the right to modify this privacy policy at any time, so
                                please review it frequently. Changes and clarifications will take
                                effect immediately upon their posting on the website. If we make
                                material changes to this policy, we will notify you here that it
                                has been updated, so that you are aware of what information we
                                collect, how we use it, and under what circumstances, if any, we
                                use and/or disclose it.
                            </li>
                            <li>
                                If our Product (“FleetOrder”) is acquired or merged with another
                                company, your information may be transferred to the new owners so
                                that we may continue to sell product to you.
                            </li>
                        </ul>
                    </div>

                    {/* QUESTIONS AND CONTACT INFORMATION */}
                    <div className="col-md-12">
                        <br />
                        <h4>QUESTIONS AND CONTACT INFORMATION</h4>
                        <ul style={{ color: "black" }} className="custom-li-bullet-points">
                            <li>
                                If you would like to access, correct, amend or delete any personal
                                information we have about you, register a complaint, or simply
                                want more information, contact our Privacy Compliance Officer at{" "}
                                <a
                                    href="mailto:sales@fleetorder.in"
                                    style={{ textDecoration: "none" }}
                                >
                                    info@fleetorder.in
                                </a>{" "}
                                or Thub Phase 2, 20, Inorbit Mall Rd, Vittal Rao Nagar, Madhapur, Hyderabad, Telangana 500081.
                            </li>
                        </ul>
                        <br />
                        <br />
                        <br />
                        <br />
                    </div>
                </div>
            </div>
        </>
    )
}

export default PrivacyAndPolicy